import { ReactElement } from 'react';
import { FieldArrayWithId } from 'react-hook-form';
import { ProviderLimitedDetail, ProviderRateTypeEnum, ShiftTypeEnum } from '../../../../api';

export interface Shift {
  startOn: string;
  endOn: string;
  startTime: string;
  endTime: string;
  presetType: ShiftTypeEnum | ProviderRateTypeEnum;
  availability: ShiftTypeEnum;
  id?: string | number;
  providerRate?: number;
  totalRatesValue?: string;
  key: string;
  isNew: boolean;
}

export interface IShiftPreset {
  label: string;
  type: ProviderRateTypeEnum | ShiftTypeEnum;
  tooltip: string;
  icon: ReactElement;
  providerPresetFieldName: IProviderPresetFieldName;
  timePeriod: EPresetTime;
  active?: boolean;
  partlyActive?: boolean;
  intermediate?: boolean;
  count?: number;
  intermediateCount?: number;
  parentIndex?: number;
}

export interface FormOutput {
  shifts: Shift[];
  comment?: string;
}

export type ShiftFieldType = FieldArrayWithId<FormOutput, 'shifts', 'id'>;
export type IndividualPresetType = Record<string, ProviderRateTypeEnum>;

export type IPresetMap = {
  [key in ProviderRateTypeEnum]: IShiftPreset;
};

// TODO: due some BE issue it temp here, but it should come as a regular api models flow
export enum EPresetTime {
  DAYSHIFT = 'DAYSHIFT_07:00-19:00',
  NIGHTSHIFT = 'NIGHTSHIFT_19:00-07:00',
  FULLDAYSHIFT = 'FULLDAYSHIFT_07:00-07:00',
  CALLSHIFT = 'CALLSHIFT_07:00-19:00',
}

export type IProviderPresetFieldName = keyof Pick<
  ProviderLimitedDetail,
  'hourly_24h_rate' | 'hourly_call_rate' | 'hourly_day_rate' | 'hourly_night_rate'
>;
